import { render, staticRenderFns } from "./entity.vue?vue&type=template&id=a88826f6&"
import script from "./entity.vue?vue&type=script&lang=js&"
export * from "./entity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports